<template>
  <validation-observer ref="form" slim>
    <div class="form-container">
      <b-form>
        <div class="wrapper">
          <b-row v-if="isAdmin">
            <b-col cols="6">
              <validation-provider
                name="Company"
                :rules="form.is_submit ? 'required' : ''"
                v-slot="{ errors }"
                slim
                class="flex-fill"
              >
                <b-form-group
                  label="Company"
                  label-size="sm"
                  label-class="font-weight-bold"
                  :invalid-feedback="errors[0]"
                >
                  <b-form-select
                    autocapitalize="off"
                    v-model="form.company_id"
                    :options="companies"
                    value-field="id"
                    text-field="name"
                    :disabled="!isNewWorkOrder"
                    :class="{ 'is-invalid': errors.length }"
                  >
                  <template #first>
                    <b-form-select-option value="" disabled>Select Company Name</b-form-select-option>
                  </template>
                  </b-form-select>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <validation-provider
                name="Contractor Name"
                rules="required"
                v-slot="{ errors }"
                slim
                class="flex-fill"
              >
                <b-form-group
                  label="Contractor Name"
                  label-size="sm"
                  label-class="font-weight-bold"
                  :invalid-feedback="errors[0]"
                >
                  <b-form-select
                    autocapitalize="off"
                    v-model="form.contractor_name"
                    :options="contractors"
                    value-field="contractorName"
                    text-field="contractorName"
                    :disabled="!isNewWorkOrder"
                    :class="{ 'is-invalid': errors.length }"
                  >
                  <template #first>
                    <b-form-select-option value="" disabled>Select Contractor Name</b-form-select-option>
                  </template>
                  </b-form-select>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="3">
              <validation-provider
                name="Validity Period"
                rules="required"
                v-slot="{ errors }"
                slim
                class="flex-fill"
              >
                <b-form-group
                  label="Validity Period"
                  label-size="sm"
                  label-class="font-weight-bold"
                  :invalid-feedback="errors[0]"
                >
                  <b-input-group>
                    <b-form-input
                      v-model="form.validity_periode_start"
                      type="text"
                      placeholder="YYYY-MM-DD"
                      autocomplete="off"
                      disabled
                    ></b-form-input>
                    <b-input-group-append>
                      <b-form-datepicker
                        v-model="form.validity_periode_start"
                        button-only
                        left
                        locale="en-US"
                        size="sm"
                        id="periode_start"
                        @input="onContext"
                        aria-controls="example-input"
                        :class="{ 'is-invalid': errors.length }"
                        :disabled="!isNewWorkOrder"
                      ></b-form-datepicker>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="3">
              <validation-provider
                name="Validity Period"
                rules="required"
                v-slot="{ errors }"
                slim
                class="flex-fill"
              >
                <b-form-group
                  label=""
                  label-size="sm"
                  label-class="font-weight-bold"
                  :invalid-feedback="errors[0]"
                >
                  <br />
                  <b-input-group>
                    <b-form-input
                      v-model="form.validity_periode_end"
                      type="text"
                      placeholder="YYYY-MM-DD"
                      autocomplete="off"
                      disabled
                    ></b-form-input>
                    <b-input-group-append>
                      <b-form-datepicker
                        v-model="form.validity_periode_end"
                        button-only
                        left
                        :min="startDate"
                        :max="endDate"
                        @input="onContext"
                        locale="en-US"
                        size="sm"
                        aria-controls="example-input"
                        :class="{ 'is-invalid': errors.length }"
                        :disabled="!isNewWorkOrder"
                      ></b-form-datepicker>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </validation-provider>
              <div style="color: red" v-if="isPeriodeNotValid">
                <p class="check-periode">Please select periode on {{this.checkContractStart}} - {{this.checkContractEnd}}</p>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <validation-provider
                name="Contract Number"
                rules="required"
                v-slot="{ errors }"
                slim
                class="flex-fill"
              >
                <b-form-group
                  label="Contract Number"
                  label-size="sm"
                  label-class="font-weight-bold"
                  :invalid-feedback="errors[0]"
                >
                  <b-form-select
                    autocapitalize="off"
                    v-model="form.contractor_id"
                    :options="contactorNum"
                    value-field="id"
                    text-field="contract_number"
                    :disabled="!isNewWorkOrder"
                    :class="{ 'is-invalid': errors.length }"
                    @change="onContractChange"
                  >
                  <template #first>
                    <b-form-select-option value="" disabled>Select Contract Number</b-form-select-option>
                  </template>
                  </b-form-select>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col>
              <validation-provider
                name="Department"
                rules="required"
                v-slot="{ errors }"
                slim
                class="flex-fill"
              >
                <b-form-group
                  label="Department"
                  label-size="sm"
                  label-class="font-weight-bold"
                  :invalid-feedback="errors[0]"
                >
                  <b-form-select
                    autocapitalize="off"
                    v-model="form.department_id"
                    :options="departments"
                    value-field="id"
                    text-field="name"
                    :disabled="!isNewWorkOrder"
                    :class="{ 'is-invalid': errors.length }"
                  >
                  <template #first>
                    <b-form-select-option value="" disabled>Select Department</b-form-select-option>
                  </template>
                  </b-form-select>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                label="Order Number"
                label-size="sm"
                label-class="font-weight-bold"
              >
                <b-form-input
                  autocapitalize="off"
                  v-model="form.order_number"
                  disabled
                />
              </b-form-group>
            </b-col>
            <b-col>
              <validation-provider
                name="Job Desc"
                rules="required"
                v-slot="{ errors }"
                slim
                class="flex-fill"
              >
                <b-form-group
                  label="Job Desc"
                  label-size="sm"
                  label-class="font-weight-bold"
                  :invalid-feedback="errors[0]"
                >
                  <b-form-select
                    autocapitalize="off"
                    v-model="form.budget_id"
                    value-field="id"
                    text-field="job_desc"
                    :options="jobDesc"
                    :disabled="!isNewWorkOrder"
                    :class="{ 'is-invalid': errors.length }"
                  >
                  <template #first>
                    <b-form-select-option value="" disabled>Select Job Desc</b-form-select-option>
                  </template>
                  </b-form-select>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <validation-provider
                name="Budget Code"
                rules="required"
                v-slot="{ errors }"
                slim
                class="flex-fill"
              >
                <b-form-group
                  label="Budget Code"
                  label-size="sm"
                  label-class="font-weight-bold"
                  :invalid-feedback="errors[0]"
                >
                  <b-form-select
                    autocapitalize="off"
                    v-model="form.budget_code"
                    :options="budgetCodes"
                    value-field="budget_code"
                    text-field="budget_code"
                    :disabled="!isNewWorkOrder"
                    :class="{ 'is-invalid': errors.length }"
                  >
                  <template #first>
                    <b-form-select-option value="" disabled>Select Budget Code</b-form-select-option>
                  </template>
                  </b-form-select>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col>
              <b-form-group
                label="Status"
                label-size="sm"
                label-class="font-weight-bold"
              >
                <b-form-input
                  autocapitalize="off"
                  v-model="form.status"
                  disabled
                />
                </b-form-group>
            </b-col>
          </b-row>
        </div>
        <b-button
          class="btn-custom mx-2 mb-2"
          variant="info"
          size="sm"
          @click="addUnit"
        >
          Add Unit
        </b-button>
        <b-table
          thead-class="bg-color text-center"
          empty-text="No data"
          :items="form.equipment_use"
          :fields="fields"
          responsive
          show-empty
        >
          <template v-slot:cell(unit_type)="{ item }">
            <validation-provider
              name="Unit Type"
              rules="required"
              v-slot="{ errors }"
              slim
              class="flex-fill"
            >
              <b-form-select
                v-model="item.contractor_equiment_id"
                value-field="id"
                text-field="name"
                @input="maxNumOfUnit"
                size="sm"
                :class="{ 'is-invalid': errors.length }"
              >
                <b-form-select-option
                  v-for="(item, index) in unitTypes"
                  :key="index"
                  :value="item.id"
                  :disabled.sync="item.notEnabled"
                >
                  {{ item.name }}
                </b-form-select-option>
              </b-form-select>
            </validation-provider>
          </template>

          <template v-slot:cell(number_of_unit)="{ item }">
            <validation-provider
              name="Number of Unit"
              :rules="form.is_submit ? 'required|min_value:1' : 'min_value:1'"
              v-slot="{ errors }"
              slim
              class="flex-fill"
            >
              <b-form-input
                autocapitalize="off"
                v-model="item.number_of_unit"
                @change="totalEstTime(item)"
                size="sm"
                :min="1"
                :max="countMaxNumberOfUnit(item.contractor_equiment_id)"
                :step="1"
                :state="item.number_of_unit ? item.number_of_unit <= countMaxNumberOfUnit(item.contractor_equiment_id) : null"
                type="number"
                autocomplete="off"
                :class="{ 'is-invalid': errors.length }"
              />
            </validation-provider>
          </template>

          <template v-slot:cell(est_time_perday)="{ item, index }">
            <validation-provider
              name="Est Time Day"
              rules="required|min_value:1"
              v-slot="{ errors }"
              slim
              class="flex-fill"
            >
              <b-form-input
                autocapitalize="off"
                v-model="item.est_time_perday"
                size="sm"
                :min="1"
                :max="maxEstTime"
                :step="1"
                type="number"
                autocomplete="off"
                @input="isEstTimeDayValid(item, index)"
                :state="item.est_time_perday ? item.est_time_perday <= maxEstTime : null"
                :class="{ 'is-invalid': errors.length }"
              />
            </validation-provider>
          </template>

          <template v-slot:cell(est_day)="{ item }">
            <validation-provider
              name="Est Day"
              rules="required|min_value:1"
              v-slot="{ errors }"
              slim
              class="flex-fill"
            >
              <b-form-input
                autocapitalize="off"
                v-model="item.est_day"
                size="sm"
                :min="1"
                :max="maxEstDay"
                :step="1"
                type="number"
                autocomplete="off"
                @input="isEstDayValid(item)"
                :state="item.est_day ? item.est_day <= maxEstDay : null"
                :class="{ 'is-invalid': errors.length }"
                :disabled="!isValidityPeriode"
              />
            </validation-provider>
          </template>
          <template v-slot:cell(total_est_time)="{ item }">
            {{ item['total_est_time'] ? item['total_est_time'].toLocaleString('en-US') : '' }}
          </template>

          <template v-slot:cell(est_cost)="{ item }">
            {{ item['est_cost'] ? item['est_cost'].toLocaleString('en-US') : '' }}
          </template>
          <template #cell(progress)="items">
            {{
              items.item.progress_usd && items.item.progress_percentage
                ? `${items.item.progress_usd} / ${items.item.progress_percentage} % ` : '-'
            }}
          </template>
          <template v-slot:cell(actions)="{ index }">
            <b-button
              variant="link"
              class="text-decoration-none text-danger ml-2 p-0"
              @click="removeUnit(index)"
            >
              <fa-icon
                icon="times-circle"
              />
            </b-button>
          </template>
        </b-table>
        <div class="d-flex mt-5">
          <b-button
            class="btn-reset mr-2 ml-auto"
            variant="outline-info"
            size="sm"
            @click="onClickBack"
          >
            Cancel
          </b-button>
          <b-button
            v-if="form.status === 'Draft'"
            class="btn-custom mr-2"
            variant="info"
            size="sm"
            @click="saveWorkOrder"
            :disabled="isPeriodeNotValid"
          >
            Save as Draft
          </b-button>
          <b-button
            class="btn-custom"
            variant="info"
            size="sm"
            @click="submitWorkOrder"
            :disabled="isPeriodeNotValid"
          >
            Submit
          </b-button>
        </div>
        <modal-successful :message="text" />
      </b-form>
    </div>
  </validation-observer>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import ModalSuccessful from '@/partials/ModalSuccessful'

export default {
  components: {
    ModalSuccessful
  },

  data: () => ({
    fields: [
      { key: 'unit_type', label: 'Unit Type', tdClass: 'text-center' },
      { key: 'number_of_unit', label: 'Number of Unit', tdClass: 'text-center' },
      { key: 'est_time_perday', label: 'Est Time/Day', tdClass: 'text-center' },
      { key: 'est_day', label: 'Est Day', tdClass: 'text-center' },
      { key: 'total_est_time', label: 'Total Est Time', tdClass: 'text-center' },
      { key: 'est_cost', label: 'Est Cost', tdClass: 'text-center' },
      { key: 'actual_wt', label: 'Actual Working Time', tdClass: 'text-center' },
      { key: 'progress', label: 'Progress ($/%)', tdClass: 'text-center' },
      { key: 'actions', label: '', tdClass: 'text-center' }
    ],
    detail: {},
    contractors: [],
    startDate: '',
    endDate: '',
    departments: [],
    budgetCodes: [],
    jobDesc: [],
    form: {
      equipment_use: [],
      budget_code: [],
      contractor_name: '',
      contractor_id: '',
      department_id: '',
      department_name: '',
      budget_id: '',
      is_draft: false,
      is_submit: false,
      company_id: ''
    },
    unitTypes: [],
    isNewWorkOrder: true,
    text: '',
    periodeStart: '',
    periodeEnd: '',
    isValidityPeriode: false,
    contractNumber: [],
    maxEstTime: 24,
    maxEstDay: 0,
    maxNumberOfUnit: 0,
    fuelPrice: null,
    companies: null,
    role: JSON.parse(localStorage.getItem('profile')).roles.name,
    checkContractStart: '',
    checkContractEnd: '',
    isPeriodeNotValid: false
  }),

  watch: {
    'form.budget_code'(value) {
      if (value) {
        this.fetchJobDesc(this.form.budget_code)
      }
    },
    'form.contractor_id'(value) {
      if (value) {
        this.fetchUnit(value)
      }
    }
  },

  computed: {
    contactorNum() {
      const value = this.form.contractor_name !== ''
        ? this.contractors.find(d => d.contractorName === this.form.contractor_name).contract_numbers : []
      return value
    },
    isAdmin() {
      return this.role === 'Administrator' || this.role === 'Super Admin'
    }
  },
  created() {
    this.addUnit()
    this.fetchContractor()
    this.fetchDepartment()
    this.fetchBudgetCode()
    this.fetchFuelPrice()
    if (this.isAdmin) {
      this.fetchCompany()
    }
    setTimeout(() => {
      this.fetctDetailWorkOrder()
    }, 1200)
  },

  methods: {
    async fetchCompany() {
      const data = await api.company.list_active()
      this.companies = data
    },
    async fetctDetailWorkOrder() {
      const data = await api.workOrder.get(this.$route.params.id)
      this.form = {
        ...data,
        validity_periode_start: data.validity_periode_start ? this.formatDate(data.validity_periode_start) : null,
        validity_periode_end: data.validity_periode_end ? this.formatDate(data.validity_periode_end) : null
      }
      this.periodeStart = this.form.validity_periode_start
      this.periodeEnd = this.form.validity_periode_end
      this.maxEstDay = this.countMaxEstDay(this.periodeStart, this.periodeEnd)
      this.isValidityPeriode = this.periodeStart && this.periodeEnd
    },
    isEstTimeDayValid(value) {
      const data = value.est_time_perday
      if (data) {
        this.totalEstTime(value)
      }
    },
    countMaxEstDay(periodeStart, periodeEnd) {
      var dateStart = moment(periodeStart)
      var dateEnd = moment(periodeEnd)
      return dateEnd.diff(dateStart, 'days') + 1 ?? 0
    },
    isEstDayValid(value) {
      const data = value.est_day
      if (data) {
        this.maxEstDay = this.countMaxEstDay(this.periodeStart, this.periodeEnd)
        this.totalEstTime(value)
      }
    },
    totalEstTime(value) {
      if (value.est_time_perday > 0 && value.number_of_unit > 0 && value.est_day > 0) {
        value.total_est_time = value.number_of_unit * value.est_time_perday * value.est_day
        const lastFuelPrice = this.fuelPrice.fuel_price_idr
        const unitType = this.unitTypes.find(d => d.id === value.contractor_equiment_id)
        const baseRate = this.fuelPrice.coal_price_nci <= this.fuelPrice.base_rate_limit ? unitType.base_rate_1 : unitType.base_rate_2
        value.est_cost = (baseRate + (unitType.fuel_cons * lastFuelPrice)) * value.total_est_time
      } else {
        value.total_est_time = null
        value.est_cost = null
      }
    },
    onClickBack() {
      this.$router.push({ path: '/work-order' })
    },
    addUnit() {
      this.form.equipment_use.push({
        contractor_equiment_id: '',
        number_of_unit: '',
        est_time_perday: '',
        est_day: '',
        total_est_time: '',
        est_cost: ''
      })
    },
    removeUnit(index) {
      this.form.equipment_use = [
        ...this.form.equipment_use.slice(0, index),
        ...this.form.equipment_use.slice(index + 1)
      ]
    },
    getCurrentMonth() {
      this.startDate = moment(this.form.validity_periode_start).startOf('month').toDate()
      this.endDate = moment(this.form.validity_periode_start).endOf('month').toDate()
    },
    onContext() {
      this.periodeStart = this.form.validity_periode_start
      this.periodeEnd = this.form.validity_periode_end
      this.isValidityPeriode = this.periodeStart && this.periodeEnd
      var dateStart = moment(this.periodeStart)
      var dateEnd = moment(this.periodeEnd)
      const numberOfDays = dateEnd.diff(dateStart, 'days') + 1
      this.maxEstDay = numberOfDays
      this.getCurrentMonth()

      this.onContractChange()
      const validityPeriodeStart = moment(this.form.validity_periode_start).format('YYYY-MM-DD')
      const validityPeriodeEnd = moment(this.form.validity_periode_end).format('YYYY-MM-DD')
      if ((validityPeriodeStart < this.checkContractStart || validityPeriodeStart > this.checkContractEnd) || (validityPeriodeEnd < this.checkContractStart || validityPeriodeEnd > this.checkContractEnd)) {
        this.isPeriodeNotValid = true
      } else {
        this.isPeriodeNotValid = false
      }
    },
    onContractChange() {
      const value = this.form.contractor_name !== ''
        ? this.contractors.find(d => d.contractorName === this.form.contractor_name).contract_numbers : []
      const contractStart = value.find(i => i.id === this.form.contractor_id).contract_periode_start
      const contractEnd = value.find(i => i.id === this.form.contractor_id).contract_periode_end
      this.checkContractStart = moment(contractStart).format('YYYY-MM-DD')
      this.checkContractEnd = moment(contractEnd).format('YYYY-MM-DD')
    },
    async fetchFuelPrice() {
      this.fuelPrice = await api.rate.fuelPrice({
        date: moment().format('YYYY-MM-DD')
      })
    },
    async fetchUnit(id) {
      this.unitTypes = await api.workOrder.contractorId(id)
      const x = this.form.equipment_use.map(d => d.contractor_equiment_id)
      // make sure user not add new unit that already in list
      this.unitTypes = this.unitTypes
        .map(d => {
          d.notEnabled = x.includes(d.id)
          return d
        })
    },
    async fetchContractor() {
      this.contractors = await api.workOrder.contractor()
      if (this.form.contractor_name) {
        this.form.contractor_id = this.contractors.find(d => d.contractorName === this.form.contractor_name).id
      }
    },
    async fetchDepartment() {
      this.departments = await api.department.list()
    },
    async fetchBudgetCode() {
      this.budgetCodes = await api.workOrder.budget()
    },
    async fetchJobDesc(value) {
      this.jobDesc = await api.workOrder.budgetCode({
        code: value
      })
      if (this.jobDesc.length === 1) {
        this.form.budget_id = this.jobDesc[0].id
      }
    },
    async submitWorkOrder() {
      this.form.is_submit = true
      this.form.is_draft = false
      this.submitCommit()
    },
    async saveWorkOrder() {
      this.form.is_draft = true
      this.form.is_submit = false
      this.submitCommit()
    },
    async submitCommit() {
      try {
        const valid = await this.$refs.form.validate()
        if (this.form.is_submit) {
          if (!valid) {
            return false
          }
        }

        const form = this.prepareForm()
        if (this.isAdmin) {
          form.company_id = this.form.company_id
        }

        if (this.form.is_draft) {
          await api.workOrder.update(this.$route.params.id, form)
          this.text = 'edit work order'
          this.$bvModal.show('modal-successful')
          setTimeout(() => {
            this.$router.push('/work-order')
          }, 1500)
        } else {
          if (form.validity_periode_start != null && form.validity_periode_end != null) {
            await api.workOrder.update(this.$route.params.id, form)
            this.text = 'edit work order'
            this.$bvModal.show('modal-successful')
            setTimeout(() => {
              this.$router.push('/work-order')
            }, 1500)
          } else {
            this.$nextTick(() => {
              this.$bvToast.toast('Validity Periode Can\'t Be Empty', {
                headerClass: 'd-none',
                solid: true,
                variant: 'danger'
              })
            })
          }
        }
      } catch ({ response }) {
        this.$nextTick(() => {
          this.$bvToast.toast(`${response.status} - ${response.data.error.message}`, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
    },
    prepareForm() {
      const depart = this.departments.find(d => d.id === this.form.department_id)
      return {
        is_draft: this.form.is_draft,
        is_submit: this.form.is_submit,
        contractor_id: this.form.contractor_id,
        budget_id: this.form.budget_id,
        validity_periode_start: this.form.validity_periode_start,
        validity_periode_end: this.form.validity_periode_end,
        department_name: depart.name,
        department_id: this.form.department_id,
        equipment_use: this.form.equipment_use
      }
    },
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD')
    },
    countMaxNumberOfUnit(value) {
      if (value && this.unitTypes.length !== 0) {
        const unitType = this.unitTypes.find(d => d.id === value)
        return unitType.unit_qty
      }
      return 0
    },
    maxNumOfUnit(value) {
      if (value && this.unitTypes.length !== 0) {
        const unitType = this.unitTypes.find(d => d.id === value)
        this.maxNumberOfUnit = unitType.unit_qty
      }

      // check item exist
      const x = this.form.equipment_use.map(d => d.contractor_equiment_id)
      this.unitTypes = this.unitTypes
        .map(d => {
          d.notEnabled = x.includes(d.id)
          return d
        })
    }
  },

  destroyed() {
    localStorage.removeItem('currentPage', this.currentPage)
    localStorage.removeItem('totalRows', this.totalRows)
  }
}
</script>

<style lang="scss">
.form-control, .custom-select {
  font-size: 12px;
}

.col-form-label,
.col-form-label-sm {
  font-size: 12px !important;
}
.check-periode {
  font-size: 12px
}
</style>
